import React from 'react';
// import PropTypes from 'prop-types';

import {Box, Paper, Stack, Typography} from 'views/components';
import {ContactSupportOutlined, ForumOutlined, TrackChanges, FactCheckOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

const HowCallWorks = (props) => {
  const callSteps = [
    {
      icon: ContactSupportOutlined,
      title: translate('careplanstep.HowCallWorks.StepAskQuestionsTitle'),
      description: translate('careplanstep.HowCallWorks.StepAskQuestionsDescription'),
    },
    {
      icon: ForumOutlined,
      title: translate('careplanstep.HowCallWorks.StepListenResponsesTitle'),
      description: translate('careplanstep.HowCallWorks.StepListenResponsesDescription'),
    },
    {
      icon: TrackChanges,
      title: translate('careplanstep.HowCallWorks.StepDiscussOutcomesTitle'),
      description: translate('careplanstep.HowCallWorks.StepDiscussOutcomesDescription'),
    },
    {
      icon: FactCheckOutlined,
      title: translate('careplanstep.HowCallWorks.StepCraftPlanTitle'),
      description: translate('careplanstep.HowCallWorks.StepCraftPlanDescription'),
    },
  ];

  return (
    <Paper sx={{padding: '32px', borderRadius: '24px', boxShadow: 'none'}}>
      <Stack sx={{gap: '32px'}}>
        <Stack sx={{gap: '4px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'careplanstep.HowCallWorks.Title'} />
          </Typography>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
            <Translate expression={'careplanstep.HowCallWorks.Description'} />
          </Typography>
        </Stack>

        <Stack sx={{gap: '16px'}}>
          {
            callSteps.map((step) => {
              const Icon = step.icon;
              return (
                <Box
                  key={step.title}
                  sx={{
                    display: 'flex',
                    gap: '20px',
                    alignItems: 'flex-start',
                    padding: '24px',
                    borderRadius: '24px',
                    backgroundColor: '#F6F2EF',
                  }}
                >
                  <Box
                    sx={{
                      width: '52px',
                      height: '52px',
                      minWidth: '52px',
                      minHeight: '52px',
                      borderRadius: '32px',
                      backgroundColor: '#FFFFFF',
                      display: 'grid',
                      placeItems: 'center',
                    }}
                  >
                    <Icon sx={{fontSize: 24, color: '#2D2925'}} />
                  </Box>
                  <Stack sx={{gap: '4px'}}>
                    <Typography sx={{fontSize: '20px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
                      {step.title}
                    </Typography>
                    <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%', paddingRight: '12px'}}>
                      {step.description}
                    </Typography>
                  </Stack>
                </Box>
              );
            })
          }
        </Stack>
      </Stack>
    </Paper>
  );
};

HowCallWorks.propTypes = {
};

export default React.memo(HowCallWorks);
